const UTC_getYear = (datePara)=> new Date(datePara).getUTCFullYear()
const UTC_getMonth = (datePara)=> new Date(datePara).getUTCMonth()
const UTC_getDate = (datePara)=> new Date(datePara).getUTCDate()
const UTC_getHours = (datePara)=> new Date(datePara).getUTCHours()
const UTC_getMinutes = (datePara)=> new Date(datePara).getUTCMinutes()
const UTC_getSeconds = (datePara)=> new Date(datePara).getUTCSeconds()

const getESTDate = (datePara)=> {
  datePara = datePara ? datePara:new Date();
  return new Date(datePara).toLocaleString("en-US","America/New_York")
}

const getESTmmddyyyy = (datePara)=> {
  return getESTDate(datePara).split(' ')[1].replace(',','')  // 月 日 年
}
const getESThms = (datePara)=> {
  let num1 = getESTDate(datePara).length
  return getESTDate(datePara).substring(num1-3)  // 时 分 秒
}
export const EST_getYear = (datePara)=> {
  return Number(getESTmmddyyyy(datePara).split('/')[2])
}
const EST_getMonth = (datePara)=> {
  return Number(getESTmmddyyyy(datePara).split('/')[0])-1
}
const EST_getDate = (datePara)=> {
  return Number(getESTmmddyyyy(datePara).split('/')[1])
}
const EST_getHours = (is0,datePara)=> {
  let data = Number(getESThms(datePara).split(':')[0])
  if (is0 === 0 && Number(data) === 24) {
    data = 0
  }
  return Number(data)
}
const EST_getMinutes = (datePara)=> {
  return Number(getESThms(datePara).split(':')[1])
}
const EST_getSeconds = (datePara)=> {
  return Number(getESThms(datePara).split(':')[2])
}

export const isUS_Dst = ()=> {
  // 美国现在是否夏令时 GMT-4
  let UTCyear = UTC_getYear()
  let UTCmonth = UTC_getMonth()
  let UTCdate = UTC_getDate()
  let UTChours = UTC_getHours()
  let UTCminutes = UTC_getMinutes()
  let UTCseconds = UTC_getSeconds()
  let us = +new Date(
    EST_getYear(),
    EST_getMonth(),
    EST_getDate(),
    EST_getHours(0),
    EST_getMinutes(),
    EST_getSeconds(),
  )
  let utc = +new Date(UTCyear,UTCmonth,UTCdate,UTChours,UTCminutes,UTCseconds)
  let timeDiff = (us - utc)/1000/60/60
  if (timeDiff == -5) {
    return false
  }else{
    return true
  }
}